import { useParams } from 'react-router-dom'
import { useEffect, useState } from 'react'
import { Center, Loader } from '@mantine/core'
import { fetchDeviceById } from '../data/device.service'
import { OnboardingDevice } from '../models/Onboarding/OnboardingDevice'
import { OnboardingLocation } from '../models/Onboarding/OnboardingLocation'
import { defaultOnboardingState } from '../models/Onboarding/OnboardingState'
import { useMsal } from '@azure/msal-react'
import { OnboardingWizard } from '../components/onboarding/OnboardingWizard'
import { HostOnboardingSteps, OnboardingWizardPages } from '../utils/constants'
import { notifications } from '@mantine/notifications'
import { getCurrentStepFromDevice } from '../utils/deviceUtils'

export default function EditDevicePage() {
  const { deviceId, locationId } = useParams<{
    deviceId: string
    locationId: string
  }>()
  const { instance } = useMsal()

  const [device, setDevice] = useState<OnboardingDevice | null>(null)
  const [location, setLocation] = useState<OnboardingLocation>({
    ...defaultOnboardingState.location,
    id: parseInt(locationId ?? '0'),
  })
  const [isLoadingDeviceInfo, setIsLoadingDeviceInfo] = useState(false)
  const [currentStep, setCurrentStep] = useState<HostOnboardingSteps>(
    HostOnboardingSteps.DeviceSetupInstructions,
  )

  useEffect(() => {
    const getDevice = async (deviceId: string | undefined) => {
      if (!deviceId || isLoadingDeviceInfo) return

      setIsLoadingDeviceInfo(true)
      try {
        const deviceData = await fetchDeviceById(deviceId)
        setDevice(deviceData)
        setCurrentStep(getCurrentStepFromDevice(deviceData))
      } catch (error: any) {
        notifications.show({
          title: 'Error',
          message: 'Failed to fetch device information',
          color: 'red',
          autoClose: false,
        })
        console.error(error)
      } finally {
        setIsLoadingDeviceInfo(false)
      }
    }

    getDevice(deviceId)
  }, [deviceId, instance])

  if (isLoadingDeviceInfo)
    return (
      <Center>
        <Loader />
      </Center>
    )

  return (
    <OnboardingWizard
      location={location}
      setLocation={setLocation}
      device={device}
      setDevice={setDevice}
      isLoadingState={isLoadingDeviceInfo}
      pageName={OnboardingWizardPages.ManageDevice}
      currentStep={currentStep}
      setCurrentStep={setCurrentStep}
    />
  )
}
